import { TimeTrackingSummaryConfig } from "../model/time-tracking-summary-config.model";

export const DEFAULT_TIME_TRACKING_SUMMARY_CONFIG: TimeTrackingSummaryConfig = {
    showTitle: true,
    shouldBoldValues: false,
    shouldBoldLabels: false,
    dateFormat: 'MMMM dd, yyyy'
}